import { useSelector } from 'react-redux';

import ENTITLEMENTS from 'enums/entitlements';
import { Optional } from 'functions/promiseExtensions';
import { areEntitlementsInUserEntitlements } from 'functions/tokenFunctions';
import { RootState } from 'reducers/rootReducer';
import * as SeasonList from 'types/_general/Store/SeasonList';

const EmptyArray = [] as any;
export function useSeasons(): SeasonList.Type {
	if (!areEntitlementsInUserEntitlements([ENTITLEMENTS.SEASON])) return EmptyArray;
	const seasons = useSelector((state: RootState) => state.seasons);
	return Optional.Maybe(seasons).getOrDefault(EmptyArray);
}

export function useAllergens() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.allergens).getOrDefault(EmptyArray)
	);
}

export function useErpSourceList() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.erpSourceList).getOrDefault(EmptyArray)
	);
}

export function useNutriScoreLabels() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.nutriScoreLabels).getOrDefault(EmptyArray)
	);
}

export function useIngredientRanges() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.ingredientRanges).getOrDefault(EmptyArray)
	);
}

export function useAccessoryRanges() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.accessoryRanges).getOrDefault(EmptyArray)
	);
}

export function useBaseIngredientRanges() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.baseIngredientRanges).getOrDefault(EmptyArray)
	);
}

export function useAccessoryRangesArchived() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.accessoryRangesArchived).getOrDefault(EmptyArray)
	);
}

export function useBaseIngredientRangesArchived() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.baseIngredientRangesArchived).getOrDefault(EmptyArray)
	);
}

export function useIngredientList() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.ingredientList).getOrDefault(EmptyArray)
	);
}

export function useTagList() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.tagList).getOrDefault(EmptyArray)
	);
}

export function useBaseIngredientList() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.baseIngredientList).getOrDefault(EmptyArray)
	);
}

export function useMenu() {
	return useSelector((state: RootState) => (state.menu ? state.menu : null));
}

export function useStatusList() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.statusList).getOrDefault(EmptyArray)
	);
}

export function useCo2Labels() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.co2Labels).getOrDefault(EmptyArray)
	);
}

export function useProductRanges() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.productRanges).getOrDefault(EmptyArray)
	);
}

export function useBaseIngredientCategories() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.baseIngredientCategories).getOrDefault(EmptyArray)
	);
}

export function useIngredientCategories() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.ingredientCategories).getOrDefault(EmptyArray)
	);
}

export function useAccessoryCategories() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.accessoryCategories).getOrDefault(EmptyArray)
	);
}

export function useNutrientList() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.nutrientList).getOrDefault(EmptyArray)
	);
}

export function useUnitList() {
	return useSelector((state: RootState) =>
		Optional.Maybe(state.unitList).getOrDefault(EmptyArray)
	);
}
